// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__FSjkR","disabled":"FileBtn_disabled__1xEQ6","warn":"FileBtn_warn__2P53X","fade":"FileBtn_fade__3me7O"};